import {
  RoadmapExpertCriteria as Data,
  RoadmapExpertCriteriaCollection as Collection,
} from '@/typings/api/Roadmap/Experts/Criteria'
import { RoadmapEvent } from '@/typings/api/RoadmapEvent'

import { BaseApiAuth } from '@/api/BaseApiAuth'
import { BaseApiParams } from '@/typings/common'


interface RoadmapExpertsCriteriaApiParams extends BaseApiParams {
  base_event_id: RoadmapEvent['id'];
}


export class RoadmapExpertsCriteriaApi extends BaseApiAuth<Data, Collection, RoadmapExpertsCriteriaApiParams> {
  protected readonly endpoint = 'publications/roadmap_experts/criterions';
}
